/*
 Initial state and properties
 */
 export const initialState = {
    mode:"POST",
    workerIdSelected:0,
    defaultDataWorker:null
 }
 /*
  Action types
  */
 export const SET_MODE = 'SET_MODE'
 export const SET_WORKER_ID = 'SET_WORKER_ID'
 export const SET_DEFAULT_DATA = 'SET_DEFAULT_DATA'
 /*
  Arrow function for change state
  */
 export const setMode = (payload) => ({
   type: SET_MODE,
   payload,
 });
 export const setWorkerId = (payload) => ({
  type: SET_WORKER_ID,
  payload,
})
export const setDefaultData = (payload) => ({
  type: SET_DEFAULT_DATA,
  payload,
})
 /*
  Reducer to describe how the state changed
  */
 export default function Reducer(state = initialState, { type, payload }) {
   switch (type) {
     case SET_MODE:
       return {
         ...state,
         mode: payload,
       }
       case SET_WORKER_ID:
        return {
          ...state,
        workerIdSelected: payload,
        }
        case SET_DEFAULT_DATA:
          return {
            ...state,
            defaultDataWorker: payload,
          }
     default:
       return state
   }
 }
 